<template>
  <section>
    <div class="personal-center-form__section">
      <div class="loan_detail_hs1">
        <div class="srot_griwsle">
          <!-- <el-steps :active="2" align-center>
            <el-step title="步骤1" description=""></el-step>
            <el-step title="步骤2" description=""></el-step>
            <el-step title="步骤3" description=""></el-step>
            <el-step title="步骤4" description=""></el-step>
            <el-step title="步骤5" description=""></el-step>
          </el-steps> -->
        </div>
        <span>申请时间　{{infoData.applyDate}}</span>
      </div>
      <div class="loan_detail_first">
        <ul class="text-center">
          <li>
            <em style="color:#333;">借款金额</em>
            <strong>¥{{infoData.applyMoney | addThousandSign(2)}}</strong>
          </li>
          <li>
            <em style="color:#333;">审核状态</em>
            <strong>{{infoData.applyStateName}} <img
              src="../../../static/images/loan_state.png"></strong>
          </li>
          <li>
            <el-button type="primary" class="btn" @click="showManager">客户经理</el-button>
            <el-button type="primary" class="btn" @click="showConcartList">电子合同</el-button>
            <i v-if="infoData.signCount > 0" class="red-point-tip"></i>
          </li>
        </ul>
      </div>

      <div class="loan_detail_second">
        <ul>
          <li><span>借款主体</span><strong :title="infoData.custName">{{infoData.custName}}</strong></li>
          <li ><span>保理费率</span><strong>{{infoData.factoringRate || '--'}}</strong></li>
          <li><span>起息日</span><strong>{{infoData.startDate || '--'}}</strong></li>
          <li><span>借款期限</span><strong>{{infoData.expires || '--'}}</strong></li>
          <li><span>银行账户</span><strong>{{infoData.bankAccount.bankAccountName | replaceBankcardNumWithStar}}</strong></li>

          <li v-if="Number(userInfo.crmCustomerType) === 1"><span>证件号</span><strong>{{infoData.custLicense}}</strong></li>
          <li v-if="Number(userInfo.crmCustomerType) === 2"><span>营业执照号</span><strong :title="infoData.custLicense">{{infoData.custLicense}}</strong></li>
          <li><span>保理服务费率</span>
            <strong v-if="infoData.factoringServiceRate">{{`${infoData.factoringServiceRate}`}}</strong>
            <strong v-else>--</strong>
          </li>
          <li><span>结息日</span><strong>{{infoData.endDate || '--'}}</strong></li>
          <li><span>还款方式</span><strong>{{infoData.repayType || '--'}}</strong></li>
          <li><span>买方名称</span><strong>{{infoData.buyerName}}</strong></li>
        </ul>
      </div>

      <div class="loan_detail_three">
        <div class="table-title">
          还款计划

            <!-- <router-link :to="toWholeRepay" class="btn" tag="button" :disabled="banRepay()">按期还款</router-link> -->
          <div class="btn_cont" v-if="Number(userInfo.crmCustomerType) === 1">
            <!-- <router-link :to="toWholeRepay" class="btn" tag="button" :disabled="banRepay()">按期还款</router-link> -->
            <!--<router-link :to="toPrepayment" class="btn" tag="button" :disabled="banRepay()">提前还款</router-link>-->
          </div>
          <div class="tips_info el-icon-information">企业用户只支持线下还款！</div>
        </div>
        <el-table class="table-body pointer" border="true" :data="repayData.repayInfoList" style="width: 100%"
                  @row-click="roRepaymentInfo">
         <!-- <el-table-column prop="period" label="期次" width="70">
            <template slot-scope="scope">
              <span class="item_index">{{scope.row.period}}</span>
            </template>
          </el-table-column>-->
          <el-table-column prop="repayPeriod" label="期数" width="80"></el-table-column>
          <el-table-column label="本金" width="110">
            <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.principal | addThousandSign(2)}}</span></template>
          </el-table-column>
          <el-table-column label="保理费" width="110">
            <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.factoringMoney | addThousandSign(2)}}</span></template>
          </el-table-column>
           <el-table-column label="保理服务费" width="110">
            <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.factoringServiceMoney | addThousandSign(2)}}</span></template>
          </el-table-column>
          <el-table-column prop="repayDate" label="计划还款日期" width="120"></el-table-column>
          <el-table-column label="计划还款金额" width="110">
            <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.repayMoneySum | addThousandSign(2)}}</span></template>
          </el-table-column>
          <el-table-column label="未还金额" width="110">
            <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.notRepayMoneySum | addThousandSign(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="payStatus"></el-table-column>
        </el-table>
        <el-pagination v-if="repayData.repayInfoList.length > 0" class="pament-list-pagination" :small="isSmall"
                       layout="prev, pager, next" :page-count="repayData.pageCount" :page-size="repayData.pageSize" :total="repayData.pageCount"
                       :current-page="repayData.pageCurrent"
                       style="text-align: center;" @current-change="changePage"></el-pagination>
      </div>
    <el-dialog class="contract dialog" top="25%" title="选择发票" :lock-scroll=true :visible.sync="showVoucherDialog">
        <el-table ref="multipleTable"
            :data="chooseVoucherInfoList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column header-align="center" align="center" type="selection" width="50"></el-table-column>
            <el-table-column header-align="center" align="center" prop="buyerName" label="买方" width="120"></el-table-column>
            <el-table-column header-align="center" align="center" prop="bizNo" label="凭证号码" ></el-table-column>
            <el-table-column header-align="center" align="center" label="凭证金额">
              <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.receivableAmount | addThousandSign(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="应收账款净额" >
              <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.netAmount | addThousandSign(2)}}</span>
                          </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px;text-align:center;">
            <el-button type="primary" class="btn" @click="addVoucher">添加发票</el-button>
            <el-button type="primary" class="btn" @click="submitChoose">提交</el-button>
          </div>          
    </el-dialog> 
      <!-- 添加凭证弹出框 -->  
      <el-dialog :visible.sync="showAddVoucherDialog" title="添加发票"
                 top="5%"
                 class="financing-dialog" :modal-append-to-body="false">
        <div class="financing-dialog-form">
           <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleForm"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <el-form-item label="类型"
                          prop="type">
              <el-select v-model="ruleForm.type"
                         placeholder="请选择类型"
                         :disabled="true" 
                         >
                <el-option label="发票"
                           value="4"
                           key="1"></el-option>
              </el-select> 
             </el-form-item>
            <el-form-item label="产品名称">
              <el-select v-model="ruleForm.baseProductId" placeholder="请选择产品" :disabled="true">
                <el-option
                  v-for="item in productList"
                  :key="item.productId"
                  :label="item.productName"
                  :value="item.productId">
                </el-option>
              </el-select>
            </el-form-item>              
            <el-form-item label="买方"
                          prop="buyerId">
              <el-select v-model="ruleForm.buyerId"
                         placeholder="请选择买方"
                         class="buyerName" :disabled="true">
                <el-option :label="item.buyerName"
                           :value="item.buyerId"
                           v-for="(item,index) in ruleForm.buyerNameList"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发票金额"
                          prop="receivableAmount">
              <el-input v-model="ruleForm.receivableAmount"
                        placeholder="请输入发票金额"></el-input>
            </el-form-item>            
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="应收账款净额"></el-input>
            </el-form-item>    
            <el-form-item label="合同编号"
                          prop="contractNumber">
              <el-input v-model="ruleForm.contractNumber"
                        placeholder="请输入合同名称及合同编号"></el-input>
            </el-form-item>
            <el-form-item label="开票日期"
                        prop="receivableStartTime">
            <el-date-picker type="date" @change="dateChange($event,'receivableStartTime')"
                            placeholder="开票日期"
                            v-model="ruleForm.receivableStartTime"
                            value-format="yyyy-MM-dd" :modal-append-to-body="false"></el-date-picker>
            </el-form-item>
            <el-form-item label="发票号码"
                          prop="bizNo">
              <el-input v-model="ruleForm.bizNo"
                        placeholder="请输入发票号码"></el-input>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model="ruleForm.orderNo"
                        placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="送货单号">
              <el-input v-model="ruleForm.deliveryNo"
                        placeholder="请输入送货单号"></el-input>
            </el-form-item>
            <el-form-item label="品名">
              <el-input v-model="ruleForm.goodsName"
                        placeholder="请输入品名"></el-input>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model="ruleForm.spec"
                        placeholder="请输入规格型号"></el-input>
            </el-form-item>
            <el-form-item label="单位">
              <el-input v-model="ruleForm.unit"
                        placeholder="请输入单位"></el-input>
            </el-form-item>
            <el-form-item label="数量">
              <el-input v-model="ruleForm.num"
                        placeholder="请输入数量"></el-input>
            </el-form-item>
            <el-form-item label="单价">
              <el-input v-model="ruleForm.unitPrice"
                        placeholder="请输入单价"></el-input>
            </el-form-item>
            <el-form-item label="总价"
                          prop="totalPrice">
              <el-input v-model="ruleForm.totalPrice"
                        placeholder="请输入总价"></el-input>
            </el-form-item>
          </el-form>  
          <ul class="file-list__item-list">
            <template v-for="file in sysFileIds">
              <li class="file-list__item-preview">
                <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`"
                     @click="showPreviewImage(file.fileId, true)">
                <div class="file-list__item-delete"
                     @click.stop="deleteUploadedFile(file)">
                  <i class="el-icon-close"></i>
                </div>
              </li>
            </template>
            <!--element-ui上传控件不支持IE9，使用webuploader插件替代 @mousedown="changeFileType(file.filesId)"-->
            <li  class="file-list__select-file picker">
            <i class="el-icon-plus"></i>
            </li>
          </ul>   
          <div style="margin-top: 20px;text-align:center;"> 
          <span slot="footer"
                class="dialog-footer pinker">
            <el-button type="primary"
                      @click="submitVoucher"
                      class="submit">提交</el-button>
          </span>
          </div>                 
        </div>
      </el-dialog>     
      <!--start 凭证列表-->
      <div class="loan_detail_three" style="margin-top: 20px;">
        <div class="table-title">
          凭证列表
          <el-button type="primary" class="btn" style="margin-left: 60%;" @click="showLoanPayApply" v-show="showChooseVoucherButton">申请融资放款</el-button>
          <el-button type="primary" class="btn" @click="chooseVoucher" v-show="showChooseVoucherButton">补充发票</el-button>
          <i v-if="infoData.payCount > 0" class="red-point-tip2"></i>
        </div>
        <div>
        </div>
        <el-table class="table-body pointer" border="true" :data="voucherInfo.voucherInfoList" style="width: 100%"
                  @row-click="roFrontVoucherInfo">
          <el-table-column label="凭证类型" width="150" prop="type"></el-table-column>
          <el-table-column label="买方" width="150" prop="buyerName"></el-table-column>
          <el-table-column label="凭证号码" width="150" prop="bizNo"></el-table-column>
          <el-table-column label="应收账款金额" width="150">
            <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.receivableAmount | addThousandSign(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="应收账款净额" width="150">
            <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.netAmount | addThousandSign(2)}}</span>
            </template>
          </el-table-column>          
          <el-table-column v-if="showVoucherState" label="审核状态" prop="authStateName" width="100"></el-table-column>
        </el-table>

        <div class="step3-amount">
          <!--
          <span>发票合同金额：<i>￥{{voucherInfoData.contractAmountSum}}</i></span>
          -->
          <span>应收账款金额：<i>￥{{voucherInfoData.receivableAmountSum | addThousandSign(2)}}</i></span>
          <span>应收账款净额：<i>￥{{voucherInfoData.netAmountSum | addThousandSign(2)}}</i></span>
          <span v-show="showSupplementNetAmountSum">补充发票净额：<i>￥{{voucherInfoData.supplementNetAmountSum | addThousandSign(2)}}</i></span>
        </div>

        <el-pagination v-if="voucherInfo.voucherInfoList.length > 0" class="pament-list-pagination" :small="isSmall"
                       layout="prev, pager, next" :page-count="voucherInfo.pageCount" :total="voucherInfo.pageCount" :page-size="voucherInfo.pageSize"
                       :current-page="voucherInfo.pageCurrent"
                       style="text-align: center;" @current-change="changePage3"></el-pagination>
      </div>
      <!--end  凭证列表-->

      <!--start 融资放款申请-->
      <div class="loan_detail_three" style="margin-top: 20px;" v-show="showLoanPayApplyList">
        <div class="table-title">
          融资放款申请列表
        </div>
        <div>
        </div>
        <el-table class="table-body pointer" :data="loanPayApplyList" style="width: 100%">
          <el-table-column label="申请金额" width="150">
            <template slot-scope="scope">
              <span style="color:#EB662B;">¥{{scope.row.applyAmount | addThousandSign(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请时间" width="150" prop="applyTime" :formatter="formatDate"></el-table-column>
          <el-table-column label="放款金额" width="150">
            <template slot-scope="scope">
              <span style="color:#EB662B;">¥{{scope.row.payAmount | addThousandSign(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="放款时间" width="150" prop="payTime" :formatter="formatDate"></el-table-column>          
          <el-table-column label="申请状态" width="150" prop="state" :formatter="formatApplyState"></el-table-column>
        </el-table>

        <!-- <div class="step3-amount">
          <span>融资申请金额：<i>￥{{voucherInfoData.receivableAmountSum | addThousandSign(2)}}</i></span>
          <span>实际放款金额：<i>￥{{voucherInfoData.netAmountSum | addThousandSign(2)}}</i></span>
        </div> -->

        <!-- <el-pagination v-if="loanPayApplyList.length > 0" class="pament-list-pagination" :small="isSmall"
                       layout="prev, pager, next" :page-count="voucherInfo.pageCount" :total="voucherInfo.pageCount" :page-size="voucherInfo.pageSize"
                       :current-page="voucherInfo.pageCurrent"
                       style="text-align: center;" @current-change="changePage3"></el-pagination> -->
      </div>
      <!--end  融资放款申请-->      

    </div>
    <!-- 融资放款申请弹窗 -->
   <el-dialog width="25%" title="融资放款申请" :visible.sync="dialogLoanPayApply" :modal-append-to-body="false" :close-on-click-modal="false" class="dialog-import" >
      <div class="financing-dialog2" style="height: 150px;">
            <el-form :model="loanPayApplyForm"
                    :rules="rulesLoanPayApply"
                    ref="loanPayApplyForm"
                    label-width="150px"
                    class="demo-ruleForm financing-dialog-form-body">
              <el-form-item label="可融资金额"
                            class="el-form-item3" width="80%">
                      ¥{{loanPayApplyForm.canPayMoney | addThousandSign(2)}}                            
              </el-form-item>
              <el-form-item label="本次申请融资金额"
                            prop="applyAmount"
                            class="el-form-item3">
                <el-input v-model="loanPayApplyForm.applyAmount"
                          placeholder="请输入本次申请融资金额"></el-input>
              </el-form-item>
            </el-form>      
          </div>
            <div slot="footer"
                class="dialog__footer">
              <span slot="footer" class="dialog-footer">
                <el-button  @click="loanPayApplySubmit">提交申请</el-button>
              </span>
            </div>     
   </el-dialog>  
    <el-dialog class="showManagerDialog" title="客户经理信息" :visible.sync="showManagerDialog">
      <dl>
        <!-- <dt><img :src="magerweimaImg"></dt> -->
        <dd>
          <div class="name_title">姓名</div>
          <div class="name_text">{{managerInfo.managerName}}</div>
          <div class="name_title">手机</div>
          <div class="name_text">{{managerInfo.managerMobile}}</div>
          <div class="name_title">邮箱</div>
          <div class="name_text">{{managerInfo.managerEmail}}</div>
        </dd>
      </dl>
    </el-dialog>

    <el-dialog class="contract dialog" top="5%" title="电子合同" :visible.sync="showAgreementDialog">
      <div class="contract__dialog-body agreement_contract">
        <img :src="readContractImg">
        <!--<div v-html="contractContent"></div>-->
      </div>
      <div slot="footer" class="dialog__footer">

        <el-button v-if="signBtn.isShow" class="dialog__footer__confirm-btn sign_btn" :disabled="signBtn.state" @click="signAgreementNew"
                   style="margin-right:30px;">
          {{signBtn.text}}
        </el-button>
        <a :href="downAgreement" class="down_agreen">下载</a>
      </div>
    </el-dialog>
    <el-dialog class="file-preview-modal"
                title="图片预览"
                :visible="filePreview.show"
                :before-close="hidePreviewImage"
                :close-on-click-modal="false">
      <div class="file-preview-modal__body">
        <img :src="filePreview.src"
              alt="图片预览">
      </div>
      <div slot="footer"
            class="dialog__footer">
        <button class="dialog__footer__confirm-btn"
                @click="hidePreviewImage">确定</button>
      </div>
    </el-dialog>

    <el-dialog class="progressDialog"
                title=" "
                :visible.sync="isShowProgress"
                size="tiny"
                top="20%"
                :show-close="false">
      <el-progress class="upload_progress"
                    :text-inside="true"
                    :stroke-width="18"
                    :percentage="progress"></el-progress>
    </el-dialog>
  </section>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import * as types from '../../vuex/types';
  import loanApi from '../../api/myloan_bl';
  import billApi from '../../api/myBill.js';
  import productsApi from '../../api/products.js';
  import Webuploader from 'webuploader';
  import 'webuploader/css/webuploader.css';
  import moment from 'moment';

  export default {
    data () {
      return {
        showVoucherState:true,//是否显示凭证审核状态
        showLoanPayApplyList:false,
        loanPayApplyList: [],
        dialogLoanPayApply: false,
        productList: [],
        showSupplementNetAmountSum: false,
        showChooseVoucherButton: false,
        chooseVoucherInfoList: [],
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        sysFileIds: [],
        progress: 0,
        isShowProgress: false,
        filePreview: {
          show: false,
          src: ''
        },
        showAddVoucherDialog: false,
        multipleSelection: '',
        showVoucherDialog: false,
        voucherInfoData: '',
        readContractImg: '',
        aleradyReceivablesAmount: 0,
        magerweimaImg: '',
        frontApplyId: this.$route.params.frontApplyId,
        pageCurrent: 1,
        pageSize: 10,
        isSmall: true,
        index: 1,
        showManagerDialog: false,
        showAgreementDialog: false,
        signBtn: {
          state: false,
          text: '签署公章',
          isShow: true
        },
        voucherInfo: {
          pageCount: '',
          pageCurrent: 1,
          pageSize: 10,
          voucherInfoList: [ // 定义凭证数据
            /* {
              "waybillNumber": "2018-8-22123456",
              "voucherInfoId": 10000065220008,
              "alreadyPaidAmount": 0,
              "frontApplyId": 10000065220003,
              "contractNumber": "2018-8-22123456",
              "contractAmount": 5000,
              "receivableAmount": 5000,
              "state": "未融资 ",
              "buyerName": "阳光城集团",
              "customerName": "符永金",
              "lnvoiceNumber": "2018-8-22123456",
              "receivableEndTime": null
            } */
          ]
        },
        infoData: {}, // 详情对象
        repayData: { // 还款列表数据
          repayInfoList: [],
          pageCount: '',
          pageCurrent: 1,
          pageSize: 10
        },
        managerInfo: {},
        flage: false, // 定义判断是否生成电子合同，true表示已生成，false为生成
        itemApplyId: '',
        loanAllDataBl: '',
        ruleForm: {
          baseProductId: '', // 产品id
          buyerNameList: [],
          type: '4', // 凭证类型（默认为发票）
          buyerId: '', // 买方（核心企业）名称
          receivableAmount: '', // 发票金额
          netAmount: '', // 应收账款净额
          receivableStartTime: '', // 开票日期
          contractNumber: '', // 合同编号
          bizNo: '', // 发票号码
          orderNo: '', // 订单号
          deliveryNo: '', // 送货单号
          goodsName: '', // 品名
          spec: '', // 规格型号
          unit: '', // 单位
          num: '', // 数量
          unitPrice: '', // 单价
          totalPrice: '' // 总价
        },
        loanPayApplyForm: {
          canPayMoney: '',
          applyAmount: ''
        },
        rulesLoanPayApply: {
          applyAmount: [
            {
              trigger: 'blur',
              required: true,
              validator: (rules, value, callback) => {
                if (_.trim(value) === '') {
                  callback(new Error('请输入本次融资申请金额'));
                } else {
                  callback();
                }
              }
            }
          ]
        },
        rules: {
          buyerId: [{ type: 'number',
            required: true,
            message: '请选择买方',
            trigger: 'blur' }],
          type: [{ type: 'string',
            required: true,
            message: '请选择类型',
            trigger: 'change' }],
          contractNumber: [
            {
              trigger: 'blur',
              required: true,
              validator: (rules, value, callback) => {
                if (_.trim(value) === '') {
                  callback(new Error('请输入合同名称及合同编号'));
                } else {
                  callback();
                }
              }
            }
          ],
          bizNo: [
            {
              trigger: 'blur',
              required: true,
              validator: (rules, value, callback) => {
                if (_.trim(value) === '') {
                  callback(new Error('请输入发票号码'));
                } else {
                  callback();
                }
              }
            }
          ],
          receivableAmount: [
            {
              trigger: 'blur',
              required: true,
              validator: (rules, value, callback) => {
                if (_.trim(value) === '') {
                  callback(new Error('请输入发票金额'));
                } else if (_.isNaN(Number(value))) {
                  callback(new Error('发票金额必须为数字'));
                } else if (Number(value) < 0) {
                  callback(new Error('发票金额不能小于0!'));
                } else {
                  callback();
                }
              }
            }
          ],
          receivableStartTime: [
            {
              trigger: 'blur',
              required: true,
              validator: (rules, value, callback) => {
                if (_.trim(value) === '') {
                  callback(new Error('请选择开票日期'));
                } else {
                  callback();
                }
              }
            }
          ]
        }
      };
    },
    computed: {
      ...mapGetters({
        loanAllData: types.GET_LOAN_INFO_DETAIL,
        userInfo: types.GET_USER,
        successModal: types.GET_SUCCESS_MESSAGE,
        failModal: types.GET_FAIL_MESSAGE,
        imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
        redContract: types.GET_CONTRACT_IMAGE_SRC,
        redContractBl: types.GET_CONTRACT_IMAGE_SRC_BL,
        frontItemApplyState: types.FRONT_ITEM_STATE_FRONT,
        ajaxBaseUrl: types.GET_AJAX_BASE_URL
      }),
      magerweima () {
        return `${this.imgSrcPrefix}${this.loanAllData.managerPicture}`;
      },
     /* magerweimaImg () {
        return `${this.imgSrcPrefix}${this.managerInfoFileId}`
      }, */
      downAgreement () {
        return `/api/mobile/item/pdfSignatureController/blReadContract.ht?download=true&fileType=PDF&identify=01&isOverseasCustome=N&loanItemApplyId=${this.loanAllDataBl.itemApplyId}&itemContractSigned=${this.loanAllDataBl.itemContractSigned}&id=${Math.random()}`;
      },
      toPrepayment () {
        return `/prepayment/${this.loanAllData.itemApplyId}?frontApplyId=${this.$route.params.frontApplyId}`;
      },
      toWholeRepay () {
        return `/wholeRepay/${this.loanAllData.itemApplyId}?frontApplyId=${this.$route.params.frontApplyId}`;
      }
    },
    methods: {
      readContract () {
        this.readContractImg = `${this.redContractBl}01&loanItemApplyId=${this.loanAllDataBl.itemApplyId}&itemContractSigned=${this.loanAllDataBl.itemContractSigned}&id=${Math.random()}`;
      },
      showManager () {  // 展示经理
        this.showManagerDialog = true;
        // alert(this.managerInfoFileId)
        this.magerweimaImg = `${this.imgSrcPrefix}${this.managerInfoFileId}`;
      },
      getContract () { // 获取电子合同

      },
      changeSignBtn () {
        if (this.loanAllDataBl.itemContractSigned === '2') {
          this.signBtn.isShow = true;
          this.signBtn.state = false;
          this.signBtn.text = '签署公章';
        } else if (this.loanAllDataBl.itemContractSigned === '3') {
          this.signBtn.isShow = true;
          this.signBtn.state = true;
          this.signBtn.text = '已签章';
        } else if (this.loanAllDataBl.itemContractSigned === '-1') {
          this.signBtn.isShow = false;
          this.signBtn.state = true;
          this.signBtn.text = '已签章';
        } else {
          this.signBtn.isShow = true;
          this.signBtn.state = false;
          this.signBtn.text = '签署公章';
        }
      },
      ...mapActions({
        getLoanAllData: types.GET_LOAN_ALL_DATA,
        signAture: types.SIGN_AGREEMENT,
        downContract: types.DOWN_AGREEMENT,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      ...mapMutations({
        setLoanAllData: types.SET_LOAN_ALL_DATA,
        setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
        setFailModal: types.SET_FAIL_MESSAGE_STATE,
        setSigned: types.SET_SIGNED
      }),
      showAgreement () {  // 电子合同展示 hgwn 直接调用接口，后台判断
//        this.flage = true
        if (this.flage == true) {
          this.readContract();
          this.showAgreementDialog = true;
        } else {
          this.setFailModal({
            show: true,
            content: '合同尚未生成，请等待客户经理审批生成合同'
          });
        }
      },
      getChooseVoucherList () {
        billApi.getFrontVoucherInfoList({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: 0,
          type: 'list',
          state: 12,
          voucherType: 4,
          pageNum: this.pageCurrent,
          pageSize: this.pageSize,
          authState: this.authState
        }).then((res) => {
          if (res.rspcode == 1) {
            this.chooseVoucherInfoList = res.data.voucherInfoList;
          }
        }).catch((error) => {});
      },
      chooseVoucher () {
        this.multipleSelection = [];
        this.showVoucherDialog = true;
        this.getChooseVoucherList();
      },
      // 融资放款申请窗口显示
      showLoanPayApply () {
        this.dialogLoanPayApply = true;
        if (this.$refs.loanPayApplyForm) {
          this.$refs.loanPayApplyForm.resetFields();
        }
        // 获取可融资金额
        loanApi.getCanPayMoney({
          frontApplyId: this.$route.params.frontApplyId
        }).then((res) => {
          if (res.code == 0) {
            this.loanPayApplyForm.canPayMoney = res.result;
          }
        });
      },
      handleSelectionChange (val) {
        this.multipleSelection = val;
      },
      addVoucher () {
          // this.showVoucherDialog = false;
        this.showAddVoucherDialog = true;
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
        if (this.uploader == undefined) {
          const _this = this;
          setTimeout(() => {
            _this.createWebUploader();
            _this.uploader.refresh();
          }, 500);
        }
      },
      // 提交添加凭证
      submitVoucher () {
        const codeSysfiled = this.sysFileIds ? encodeURIComponent(JSON.stringify(this.sysFileIds)) : '';
        const sameType = {
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          voucherInfoId: 0, // 凭证id(主键)
          frontApplyId: 0, // 项目id
          type: 4, // 类型
          buyerId: this.ruleForm.buyerId, // 买方
          sysFileIds: codeSysfiled// 附件
        };
        let params = {};
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.receivableStartTime, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              bizNo: this.ruleForm.bizNo, // 发票号码
              orderNo: this.ruleForm.orderNo, // 订单号
              receiptNo: '',  // 收货单号
              deliveryNo: this.ruleForm.deliveryNo, // 送货单号
              goodsName: this.ruleForm.goodsName, // 品名
              spec: this.ruleForm.spec, // 规格型号
              unit: this.ruleForm.unit, // 单位
              num: this.ruleForm.num, // 数量
              unitPrice: this.ruleForm.unitPrice, // 单价
              totalPrice: this.ruleForm.totalPrice, // 总价
              receivableAmount: this.ruleForm.receivableAmount, // 发票金额
              baseProductId: this.ruleForm.baseProductId// 产品id
            };
            billApi.saveFrontVoucherInfo(params).then((res) => {
              if (res.rspcode == 1) {
                this.setSuccessMessage({
                  show: true,
                  content: res.rspdesc
                });
                this.showAddVoucherDialog = false;
                this.getChooseVoucherList();
              } else {
                this.setFailMessage({
                  show: true,
                  content: res.rspdesc
                });
              }
            })
            .catch((error) => {});
          }
        });
      },
      // 提交确定
      submitChoose () {
        if (this.multipleSelection.length < 1) {
          this.setFailModal({
            show: true,
            content: '请选择需要提交的发票'
          });
        } else {
          let voucherInfoIds = '';
          for (let i = 0; i < this.multipleSelection.length; i++) {
            if (i == 0) {
              voucherInfoIds = voucherInfoIds + this.multipleSelection[i].voucherInfoId;
            } else {
              voucherInfoIds = `${voucherInfoIds},${this.multipleSelection[i].voucherInfoId}`;
            }
          }
          this.$confirm('提交后不允许修改,是否确定提交发票?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            billApi.replenishVoucherInfoFront({
              voucherInfoIds,
              frontApplyId: this.$route.params.frontApplyId
            }).then((res) => {
              if (res.code == 0) {
                this.setSuccessModal({
                  show: true,
                  content: '补充发票成功'
                });
                this.getFrontVoucherInfoList();
                this.showVoucherDialog = false;
              } else {
                this.setFailModal({
                  show: true,
                  content: '补充发票失败，请联系管理员'
                });
              }
            });
          });
        }
      },
      // 提交融资放款申请
      loanPayApplySubmit () {
        this.$refs.loanPayApplyForm.validate((valid) => {
          if (valid) {
            loanApi.applyLending({
              itemApplyId: this.$route.params.frontApplyId,
              applyAmount: this.loanPayApplyForm.applyAmount
            }).then((res) => {
              if (res.code == 0) {
                this.setSuccessModal({
                  show: true,
                  content: '申请成功，请耐心等待审批!'
                });
                this.dialogLoanPayApply = false;
                    // 重新获取融资申请列表
                this.getLoanPayApplyList();
              } else {
                this.setFailModal({
                  show: true,
                  content: res.msg
                });
              }
            });
          }
        });
      },
      toggleSelection (rows) {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      // 展示合同列表
      showConcartList () {
        this.$router.push({path: '/personalCenter/projectContract/list', query: { frontApplyId: this.$route.params.frontApplyId }});
      },
      changePage (currentPage) {
        this.repayData.pageCurrent = currentPage;
        this.getRepayList();
      },
      changePage3 (currentPage) {
        this.voucherInfo.pageCurrent = currentPage;
        this.getFrontVoucherInfoList();
      },
      getData () {
        this.getLoanAllData({
          token: this.userInfo.token,
          frontApplyId: this.frontApplyId,
          pageCurrent: this.pageCurrent,
          pageSize: this.pageSize,
          frontItemApplyState: this.frontItemApplyState
        }).then((res) => {
          const data = res.data;
          if (Number(data.code) === 0) {
            this.setLoanAllData(data.data);
            setTimeout(() => {
              this.changeSignBtn();
            }, 300);
          } else {
            this.setFailModal({
              show: true,
              content: data.result
            });
          }
        });
      },
      signAgreementNew () { // 保理电子合同签章 2018/9/20
        const _this = this;
       // this.loanAllData.itemContractSigned === '2'
        if (true) {
          this.signBtn.state = true;
          this.signBtn.text = '签章中…';
          loanApi.signContract({
            itemApplyId: this.loanAllDataBl.itemApplyId || ''
          }).then((res) => {
            if (res.code === 0) {
              this.readContract();
              this.loanAllDataBl.itemContractSigned = res.itemContractSigned;
              _this.buttonState = false;
              _this.setSuccessModal({
                show: true,
                content: res.result
              });
              _this.changeSignBtn();
            } else {
              _this.setFailModal({
                show: true,
                content: res.result
              });

              this.signBtn.text = '签署公章';
              this.signBtn.state = false;
//              _this.changeSignBtn()
            }
          }).catch((error) => {

          });
        } else {
          this.setFailModal({
            show: true,
            content: '合同已签章！'
          });
        }
      },
      signAgreement () {
        const _this = this;
        if (this.loanAllData.itemContractSigned === '2') {
          this.signBtn.state = true;
          this.signBtn.text = '签章中…';
          this.signAture({
            itemApplyId: this.loanAllData.itemApplyId
          }).then((res) => {
            const data = res.data;
            if (data.code === 0) {
              _this.buttonState = false;
              _this.setSigned(data);
              _this.setSuccessModal({
                show: true,
                content: data.result
              });
              _this.changeSignBtn();
            } else if (data.code === 1) {
              this.setFailModal({
                show: true,
                content: data.result
              });
              _this.changeSignBtn();
            }
          });
        } else {
          this.setFailModal({
            show: true,
            content: '合同已签章！'
          });
        }
      },
      roRepaymentInfo (row) { // 还款列表详情
        this.$router.push({path: `/repaymentInfo_bl/${row.repayPeriod}/${row.financePayId}`});
      },
      roFrontVoucherInfo (row) { // 凭证详情
        this.$router.push({path: `/FrontVoucherInfo_bl/${row.frontApplyId}/${row.voucherInfoId}`});
      },
      // banRepay () {
      //   switch (this.loanAllData.frontApplyState) {
      //     case '32':
      //       return false
      //     default:
      //       return true
      //   }
      // }
      banRepay () {
        switch (this.loanAllData.advRePayState) {
          case '1':
            return false;
          default:
            return true;
        }
      },
      getInfo () {
        loanApi.getItemDetails({ // 详情
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: this.$route.params.frontApplyId
        }).then((res) => {
          if (res.rspcode == 1) {
            this.infoData = res.data;
            this.ruleForm.buyerId = res.data.buyerId;
            this.ruleForm.baseProductId = this.infoData.frontApply.productId;
            // 产品类型为送货融资或票据融资 且 已经放款 显示补充发票操作按钮
            if ((res.data.productClassification == '4' || res.data.productClassification == '5') && res.data.isPay == 1) {
              this.showChooseVoucherButton = true;
              this.showSupplementNetAmountSum = true;
              this.showLoanPayApplyList = true;
            }else{
              this.showLoanPayApplyList = false;
              if(res.data.productClassification == '6'){//供应链产品不显示凭证审核状态
                this.showVoucherState = false;
              }
            }
            this.managerInfo = res.data.managerInfo;
            // this.managerInfoFileId= res.data.managerInfo.managerPicture[0].fileId;
            if (res.data.flage) {
              this.flage = res.data.flage;
              this.itemApplyId = res.data.itemApplyId;
              this.loanAllDataBl = res.data;
            }
            this.changeSignBtn();
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        }).catch((error) => {

        });
      },
      getRepayList () { // 还款计划列表
        loanApi.getRepayList({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: this.$route.params.frontApplyId,
          pageNum: this.repayData.pageCurrent,
          pageSize: this.repayData.pageSize
        }).then((res) => {
          if (res.rspcode == 1) {
            this.repayData.repayInfoList = res.data.repayList;
            this.repayData.pageCount = res.data.repayCount;
          }
        }).catch((error) => {

        });
      },
      dateChange (e, type) {
        if (e) {
          const date = e.replace(/(\s*)/g, '').replace(/年/, '-').replace(/月/, '-').replace(/日/, '');
          this.ruleForm[`${type}`] = date;
          if (type == 'receivableStartTime') {
            this.ruleForm.receivableStartTime = date;
          } else if (type == 'receivableEndTime') {
            this.ruleForm.receivableEndTime = date;
          }
        }
      },
      // 初始化买方数据
      buyerNameData () {
        billApi.addFrontVoucherInfoPage({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: 0
        }).then((res) => {
          if (res.rspcode == 1) {
            this.ruleForm.buyerNameList = res.data;
          }
        }).catch((error) => {});
      },
      getFrontVoucherInfoList () { // 凭证列表
        loanApi.getFrontVoucherInfoList({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: this.$route.params.frontApplyId,
          pageSum: this.voucherInfo.pageCurrent,
          pageSize: this.voucherInfo.pageSize,
          type: 'get'
        }).then((res) => {
          if (res.rspcode == 1) {
            this.voucherInfoData = res.data;
            this.voucherInfo.voucherInfoList = res.data.voucherInfoList;
            this.voucherInfo.pageCount = res.data.voucherInfoCount;

            res.data.voucherInfoList.map((item, index) => {
              this.aleradyReceivablesAmount = (this.aleradyReceivablesAmount * 100 + item.alreadyPaidAmount * 100) / 100;
            });
          }
        }).catch((error) => {

        });
      },
      // upload-start
      showPreviewImage (fileId, isImage) {
        const src = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${this.userInfo.token}`;
        if (isImage) {
          this.filePreview = {
            show: true,
            src
          };
        } else {
          window.open(`${location.origin}${src}`);
        }
      },
      hidePreviewImage () {
        this.filePreview.show = false;
      },
      // 删除附件
      deleteUploadedFile (file) {
        const fileIndex = _.findIndex(
          this.sysFileIds,
          item => item.fileId === file.fileId
        );
        this.sysFileIds.splice(fileIndex, 1);
      },
      uploadBeforeSend (obj, data) {
        (data.tokenId = localStorage.getItem('dl_tokenId_bl')),
          (this.isShowProgress = true);
      },
      uploadProgress (file, percent) {
        const _this = this;
        _this.progress = percent * 100;
      },
      uploadSuccess (file, res) {
        const _self = this;
        const arr = _.split(res, ':');
        this.sysFileIds.push({
          fileId: Number(arr[0].replace('sysFile=', '')),
          fileName: file.name,
          uploaderId: file.id // 上传文件id
        });
        const newFile = {
          fileId: Number(arr[0].replace('sysFile=', '')),
          fileName: file.name,
          uploaderId: file.id // 上传文件id
        };
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadError (file, reason) {
        if (reason === 'http') {
          this.setFailMessage({
            show: true,
            content: '上传出错！请更新浏览器到最新版本或使用谷歌浏览器上传！'
          });
        }
        this.uploader.removeFile(file, true);
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadValidata (type) {
        switch (type) {
          case 'F_DUPLICATE': // 是否重复
            this.setFailMessage({
              show: true,
              content: '该文件您已经上传过了，请不要重复上传！'
            });
            break;
          case 'Q_TYPE_DENIED': // 文件类型是否满足
            this.setFailMessage({
              show: true,
              content:
                '请上传后缀为.jpg，的文件'
            });
            break;
          case 'Q_EXCEED_SIZE_LIMIT': // 文件大小是否超出
            this.setFailMessage({
              show: true,
              content: '请上传大小不超过10M的文件'
            });
            break;
        }
      },
      createWebUploader () {
        this.uploader = Webuploader.create({
          auto: true, // 自动上传
          swf: './static/Uploader.swf',
          server: `${
            this.ajaxBaseUrl
          }/mobile/crmCustomerAttachInfoController/saveFile.ht`,
          pick: {
            id: '.picker',
            multiple: true
          },
          chunked: true,
          duplicate: true, // 去重
          fileSizeLimit: 1024 * 1024 * 10,
          accept: {
            title: '*',
            extensions: 'gif,jpg,jpeg,png',
            mimeTypes:
              'image/*'
          }
        });
        this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
        this.uploader.on('uploadProgress', this.uploadProgress);
        this.uploader.on('uploadSuccess', this.uploadSuccess);
        this.uploader.on('uploadError', this.uploadError);
        this.uploader.on('error', this.uploadValidata);
      },
      // upload-end
      rowStyle ({ row, rowIndex}) {
        return 'color:green';
      },
      headerRowStyle ({row, column, rowIndex, columnIndex}) {
        // return 'text-align: center';
        return 'color:green';
      },
    // 获取产品列表
      getProductList () {
        productsApi.getProductListData({
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }).then((res) => {
          if (Number(res.rspcode) === 1) {
            this.productList = res.data.proList;
          }
        });
      },
    // 获取融资申请列表
      getLoanPayApplyList () {
        loanApi.loanPayApplyList({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: this.$route.params.frontApplyId
        }).then((res) => {
          if (res.code == 0) {
            this.loanPayApplyList = res.result;
          }
        });
      },
      formatDate (row, column) {
        const date = row[column.property];
        console.log(JSON.stringify(date));
        if (date == undefined) {
          return '--';
        }
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
      },
      formatApplyState (row, column) {
        const state = row[column.property];
        if (state == 1) {
          return '待审批';
        } else if (state == 2) {
          return '审批中';
        } else if (state == 3) {
          return '已放款';
        } else if (state == 4) {
          return '已拒绝';
        } else {
          return '状态不明';
        }
      }

    },
    mounted () {
      // this.getData()
      this.getProductList();
      this.getInfo();
      this.getRepayList();
      this.getFrontVoucherInfoList();
      this.buyerNameData();
      this.getLoanPayApplyList();
    }
  };
</script>
<style lang="scss" scope>
  .showManagerDialog {
    dl {
      overflow: hidden;

      dt {
        width: 159px;
        height: 159px;
        overflow: hidden;
        float: left;
        background: $darkerGray;

        img {
          width: 100%;
          height: 100%
        }
      }

      dd {
        width: 232px;
        height: 159px;
        float: right;

        .name_title {
          color: $lightWaterBlue;
          font-size: 12px;
          line-height: 24px;
        }

        .name_text {
          color: $personalCenterTitleBlack;
          font-size: 20px;
          margin-bottom: 10px;
          font-weight: bold;
        }
      }
    }

    .el-dialog__body {
      padding: 0;
    }
    .el-dialog {
      width: 485px;
      height: 274px;
      padding: 0 26px;
      box-sizing: border-box;

      .el-dialog__header {
        padding: 20px 0;

        .el-dialog__headerbtn {
          width: 12px;
          height: 12px;
          color: #A9A9A9;
          margin: -22px -22px 0 0;
        }
      }
      .el-dialog__title {
        font-size: 20px;

        &:after {
          display: block;
          content: "";
          font-size: 12px;
          line-height: 22px;
          text-indent: 8px;
          font-weight: normal;
          font-family: "Microsoft YaHei";
        }
      }
    }
  }

  .loan_detail_hs1 {
    // height: 35px;
    // line-height: 35px;
    height: initial !important;
    margin-bottom: 0;
    text-align: center;
    // overflow: hidden;
    display: flex;
    .srot_griwsle{
      flex: 1;
      height: 20px;
    }
    span {
      float: initial !important;
      font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
      font-size: 10px;
      font-weight: normal;
      color: $lightSilver;
    }
  }

  .loan_detail_first {
    overflow: hidden;

    ul {
      width: 100%;
      height: 156px;
      margin-bottom: 20px;
      box-sizing: border-box;
      overflow: hidden;
      padding: 30px 15px 0 15px;
      border-radius: 7px;
      background: $white;

      li {
        width: 278px;
        height: 95px;
        float: left;
        border-left: 1px solid #eee;
        font-size: 25px;
        color: #59402E;
        font-weight: bold;
        position: relative;
        &:first-child {
          border: none;

          em:after {
            content: '';
          }
        }

        &:nth-child(2) {
          em:after {
            content: '';
          }
        }

        em {
          display: block;
          font-size: 17px;
          color: #333;
          line-height: 38px;
          font-style: normal;
          font-family: "FZLanTingHei_GBK";

          &:after {
            display: block;
            color: #3E454D;
            font-size: 12px;
            line-height: 12px;
            font-family: "MyriadPro-Regular";
          }
        }

        strong {
          display: block;
          line-height: 47px;
          font-family: "MyriadPro-Regular", "Microsoft YaHei";
          font-size: 22px;
          color: #374B5E;

          img {
            vertical-align: -3px;
          }
        }

        .btn {
          display: block;
          width: 109px;
          height: 36px;
          margin: 8px auto;
          background: #374B5E;
          border-color: #D6DADE;
        }
      }
    }
  }

  .loan_detail_second {
    margin-bottom: 20px;
    overflow: hidden;

    ul {
      width: 100%;
      height: 187px;
      box-sizing: border-box;
      border-radius: 7px;
      padding: 26px 20px;
      background: $white;

      li {
        padding-left: 20px;
        box-sizing: border-box;
        height: 64px;
        overflow: hidden;
        float: left;
        border-right: 1px solid #eee;

        span {
          display: block;
          height: 26px;
          color: #000;
          font-weight: bold;
          font-size: 12px;
          line-height: 28px;
        }
        strong {
          width: 94%;
          display: block;
          height: 26px;
          color: #34495e;
          font-weight: 100;
          font-size: 14px;
          line-height: 28px;
          overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
        }
      }

      li:first-child {

        width: 202px;
        padding-left: 0;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(2) {

        width: 154px;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(3) {

        width: 140px;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(4) {

        width: 150px;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(5) {
        width: 184px;
        border: none;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(6) {

        width: 202px;
        padding-top: 14px;
        padding-left: 0;
      }
      li:nth-child(7) {

        width: 154px;
        padding-top: 14px;
        border-bottom: none;
      }
      li:nth-child(8) {

        width: 140px;
        padding-top: 14px;
        border-bottom: none;
      }
      li:nth-child(9) {

        width: 150px;
        padding-top: 14px;
        border-bottom: none;
      }
      li:nth-child(10) {
        width: 184px;
        padding-top: 14px;
        border: none;
      }
    }
  }

  .loan_detail_three {
    overflow: hidden;
    border-radius: 3px;
    background: $white;

    .table-title {
      height: 45px;
      overflow: hidden;
      line-height: 50px;
      font-size: 16px;
      color: #34495e;
      text-indent: 18px;
      .btn_cont {
        display: inline-block;
        float: right;
        margin-right: 10px;

        .btn {
          display: inline-block;
          margin-right: 13px;
          width: 87px;
          height: 28px;
          line-height: 26px;
          text-indent: 0;
          text-align: center;
          border-radius: 3px;
          font-size: 14px;
          border: 1px solid $orange;
          color: $orange;
          cursor: pointer;
          background-color: transparent;
          &[disabled] {
            cursor: not-allowed;
            box-shadow: none;
            background-color: transparent;
            opacity: .65;
          }

        }
      }
    }

    .step3-amount{
      margin: 15px 0 15px 20px;
      font-size: 14px;
      color: #999;
      span{
        display: inline-block;
        width: 32%;
        i{
          color: #EB662B;
          font-style: normal;
          font-size: 16px;
        }
      }
    }

    .pament-list-pagination {
      margin: 15px auto;
    }

    .tips_info {
      position: relative;
      height: 50px;
      color: #00C0FF;
      font-size: 14px;
      top: -2px;

      &:before {
        margin-right: 5px;
      }
    }
  }

  .agreement_contract {
    height: auto;
    min-height: 270px;

    img {
      width: 100%;
      height: auto;
    }
  }

  .sign_btn:hover {
    color: $white;
  }
  .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{background-color:#eee;}

  .down_agreen ,.sign_btn:hover{
    display: inline-block;
    border: 0;
    min-width: 120px;
    height: 45px;
    border-radius: 3px;
    font-size: 16px;
    color: #fff;
    line-height: 45px;
    text-align: center;
    background: #ff8b38
  }
  .financing-dialog {
    .financing-dialog-form-body {
      // overflow: hidden;
    }
    .step3Close {
      color: #ff8b38;
      text-align: right;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .el-form-item {
      width: 50%;
      float: left;
      height: 37px;
    }
    .el-form-item3 {
      width: 80%;
      float: left;
    }    
    .el-form-item3 .el-form-item__label{
        width:150px;
    }
    .el-form-item__label {
      /*color: #ff8b38;*/
    }
    .el-dialog__body {
      padding: 50px 20px 20px;
    }
    .el-dialog__footer {
      width: 100%;
      display: flex;
      justify-content: center;
      .el-button {
        width: 100px;
        margin-bottom: 30px;
      }
      .el-button:first-child {
        background: #EB662B;
        color: $white;
        border-color: #EB662B;
      }
    }
    .el-input,
    .el-select {
      width: 100%;
      float: left;
      .el-input__inner,
      .el-input {
        width: 100%;
      }
    }
    .file-list__item-preview,
    .file-list__select-file {
      width: 48%;
    }
  }  
  .financing-dialog2 {
    .step3Close {
      color: #ff8b38;
      text-align: right;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .el-form-item {
      width: 80%;
      float: left;
      height: 37px;
    }
    .el-dialog__body {
      padding: 50px 20px 20px;
    }
    .el-dialog__footer {
      width: 100%;
      display: flex;
      justify-content: center;
      .el-button {
        width: 100px;
        margin-bottom: 30px;
      }
      .el-button:first-child {
        background: #EB662B;
        color: $white;
        border-color: #EB662B;
      }
    }
    .el-input{
      width: 100%;
      float: left;
      .el-input__inner,
      .el-input {
        width: 100%;
      }
    }
    .file-list__item-preview,
    .file-list__select-file {
      width: 48%;
    }
  }    
  .red-point-tip {
    position: absolute;
    top: 50px;
    left: 185px;
    background: #f00;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: inline-block;
  }
  .red-point-tip2 {
    margin: 0 0 15px -10px;
    background: #f00;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: inline-block;
  }
</style>




// WEBPACK FOOTER //
// LoanDetail_bl.vue?ee9242ea